// extracted by mini-css-extract-plugin
export default {"banner":"banner__2r8_z","icon":"icon__2U5Zp","error":"error__AcbiB","success":"success__1mnHS","warning":"warning__15u1-","info":"info__1dHzi","neutral":"neutral__36m3h"};